import SellOut from '../../spa/sell-out/SellOut';

export default {
  path: 'sellout',
  name: 'sellout',
  component: SellOut,
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/config/router/sell-out.js